import { Card, Heading } from '@moia-dev/pace-web'

export const PatternCard = ({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) => {
  return (
    <Card
      css={theme => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.space.Space4,
      })}
    >
      <Heading>{title}</Heading>
      <div
        css={theme => ({
          display: 'flex',
          flexDirection: 'column',
          gap: theme.space.Space2,
        })}
      >
        {children}
      </div>
    </Card>
  )
}
